import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormField } from '../components/FormField';
import { Button } from '../components/Button';
import { verify, resendVerification } from '../api/auth';
import { ApiError } from '../api/client';

export function Verify() {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [email, setEmail] = useState(search.get('email') ?? '');
  const [code, setCode] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [submitting, setSubmitting] = useState(false);
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const next: Record<string, string> = {};
    if (!email.trim()) next.email = 'Enter your email.';
    if (!code.trim()) next.code = 'Enter the code from your email.';
    setErrors(next);
    if (Object.keys(next).length) return;

    setSubmitting(true);
    try {
      await verify(email.trim().toLowerCase(), code.trim());
      navigate('/login');
    } catch (err) {
      const e2 = err as ApiError;
      setErrors({ form: e2.message || "That code didn't work. Try again or resend." });
    } finally {
      setSubmitting(false);
    }
  };

  const resend = async () => {
    if (!email.trim()) { setErrors({ email: 'Enter your email first.' }); return; }
    setResending(true);
    try {
      await resendVerification(email.trim().toLowerCase());
      setResent(true);
      setErrors({});
    } catch (err) {
      const e2 = err as ApiError;
      setErrors({ form: e2.message || 'Could not resend the code.' });
    } finally { setResending(false); }
  };

  return (
    <form onSubmit={submit}>
      <h1 style={{ marginBottom: 8 }}>Verify your email</h1>
      <p style={{ color: 'var(--muted)', marginBottom: 24 }}>
        We sent a 6-digit code to your email. Pop it in below.
      </p>

      <FormField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} error={errors.email} />
      <FormField label="Verification code" inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" error={errors.code} />

      {errors.form ? <p style={{ color: 'var(--error)', fontSize: 14 }}>{errors.form}</p> : null}
      {resent ? <p style={{ color: 'var(--green)', fontSize: 14 }}>We sent a new code.</p> : null}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 16 }}>
        <Button label="Verify and continue" type="submit" loading={submitting} />
        <button type="button" onClick={resend} disabled={resending}
          style={{ background: 'transparent', border: 'none', color: 'var(--green)', textDecoration: 'underline', cursor: 'pointer', padding: 8 }}>
          {resending ? 'Sending…' : 'Resend the code'}
        </button>
      </div>
    </form>
  );
}
